export const validationMessages = {
  name: [
    { type: "required", message: "Campo obligatorio" },
    { type: "pattern", message: "Escribe también tu apellido" },
  ],
  phone: [
    { type: "required", message: "Campo obligatorio" },
    { type: "minlength", message: "Faltan números" },
    { type: "maxlength", message: "Demasiados números" },
    { type: "pattern", message: "Número inválido" }
  ],
  email: [
    { type: "required", message: "Campo obligatorio" },
    { type: "email", message: "Correo inválido" },
    { type: 'pattern', message: 'Correo inválido' }
  ],
  policy: [
    { type: "required", message: "Debes aceptar la política de privacidad" },
  ],
  shippingAddress: [
    {
      type: "required",
      message: "Este campo es obligatorio",
    },
  ],
  billingAddress: [
    {
      type: "required",
      message: "Este campo es obligatorio",
    },
  ],
  form: [
    {
      type: "zoneRestricted",
      message: "Lo sentimos pero el envío a tu localidad no está disponible",
    },
  ],
  ocupation: [
    {
      type: "required",
      message:
        'Debes seleccionar una opción. Puedes seleccionar "Prefiero no decirlo".',
    },
  ],
  gender: [
    {
      type: "required",
      message:
        'Debes seleccionar una opción. Puedes seleccionar "Prefiero no decirlo".',
    },
  ],
};
